export default {
  status: {
    open: 'Aberto',
    closed: 'Fechado',
  },
  offline_until: 'Offline até',
  closed_until: 'Fechado até',
  online_orders_paused: 'Encomendas online pausadas',
  online_orders_paused_until: 'Encomendas online pausadas até',
  reopens: 'Reabre',
  opens_today: 'Abre hoje',
  opens: 'Abre',
  open: 'Aberto',
  open_whole_day: 'Aberto todo o dia',
  outside_ordering_times: 'Fora do horário de encomendas',
};
